import { DecimalPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'bpsToRoundedPercents',
  standalone: false,
})
export class BpsToRoundedPercentsPipe implements PipeTransform {
  constructor(private decimalPipe: DecimalPipe) {}

  transform(valueBps: number, locale?: string): string {
    if (valueBps === null || valueBps === undefined) return '';

    const percent = valueBps / 100;
    const digitsInfo = percent < 4 ? '1.0-2' : '1.0-1';

    return this.decimalPipe.transform(percent, digitsInfo, locale) + '%';
  }
}
